function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import styled from "styled-components";
import useToggle from "@sprout/hooks/dist/useToggle";
import JumpToItem from "./JumpTo_Item";
import JumpToGroupExpandButton from "./JumpToGroupExpandButton";
const Ul = styled.ul`
  list-style-type: none;
`;
const JumpToGroup = (props)=>{
    const { title , items , getItemProps , collapsible  } = props;
    const [open, setOpen, setClose] = useToggle(true);
    const key = `expand_${title}`;
    useEffect(()=>{
        const state = localStorage.getItem(key);
        if (state === "false") setClose();
    }, [
        key,
        setClose,
        title
    ]);
    const handleClick = useCallback(()=>{
        if (open) {
            setClose();
            localStorage.setItem(key, "false");
        } else {
            setOpen();
            localStorage.removeItem(key);
        }
    }, [
        key,
        open,
        setClose,
        setOpen
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            title !== "NO MATCH" && /*#__PURE__*/ _jsx(JumpToGroupExpandButton, {
                title: title,
                isExpanded: open,
                onClick: handleClick,
                disabled: !collapsible
            }),
            (!collapsible || open) && /*#__PURE__*/ _jsx(Ul, {
                className: title === "NO MATCH" ? "JumpToNoMatchGroup" : undefined,
                children: items.map((item)=>{
                    return /*#__PURE__*/ _jsx(JumpToItem, _objectSpread({}, getItemProps && getItemProps({
                        item
                    }), item), `${title}-${item.url || item.action}`);
                })
            })
        ]
    });
};
export default JumpToGroup;
